////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const itemCatalogDetail = {
	[ActionsTypes.GET_ITEM_CATALOG_DETAIL]: (state) =>
		update(state, {
			itemCatalogDetail: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_ITEM_CATALOG_DETAIL_SUCCESS]: (state, payload) => {
		let itemDetail = payload.data
		return update(state, {
			itemCatalogDetail: {
				isLoading: {
					$set: false,
				},
				itemsDetail: {
					$set: itemDetail,
				},
			},
		})
	},
	[ActionsTypes.GET_ITEM_CATALOG_DETAIL_FAILURE]: (state, payload) =>
		update(state, {
			itemCatalogDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_ITEM_CATALOG_DETAIL_FILTERS_STOCKS]: (state, payload) => {
		return update(state, {
			recapStock: {
				filtersInfos: {
					$set: payload.filtersInfos,
				},
			},
		})
	},
	[ActionsTypes.SET_ITEM_CATALOG_DETAIL_SALEBYARTICLE]: (state, payload) => {
		return update(state, {
			salesByArticleHistoryManager: {
				itemCatalog: {
					$set: payload.row,
				},
			},
		})
	},
	[ActionsTypes.RESET_ITEM_CATALOG_DETAIL]: (state) => {
		return update(state, {
			itemCatalogDetail: {
				itemsDetail: {
					$set: {},
				},
			},
		})
	},
}

export default itemCatalogDetail
